// ─── Multilingual kinship term translations ────────────────────────
// Maps from Mien kinship terms to translations in all supported languages
// When the backend API is connected, this will be replaced by live data

export const SUPPORTED_LANGUAGES = [
  { code: 'mien', label: 'Mien', flag: '🏔️' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'th', label: 'Thai', flag: '🇹🇭' },
  { code: 'lo', label: 'Lao', flag: '🇱🇦' },
  { code: 'vi', label: 'Vietnamese', flag: '🇻🇳' },
  { code: 'zh', label: 'Mandarin', flag: '🇨🇳' },
];

export const DEFAULT_LANGUAGE = 'mien';

const TRANSLATIONS = {
  // Self
  'Self': {
    mien: 'Self',
    en: 'Self',
    th: 'ตัวเอง',
    lo: 'ຕົນເອງ',
    vi: 'Bản thân',
    zh: '自己',
  },
  // Parents
  'Dauv': {
    mien: 'Dauv',
    en: 'Father',
    th: 'พ่อ',
    lo: 'ພໍ່',
    vi: 'Cha',
    zh: '父亲',
  },
  'Nerh': {
    mien: 'Nerh',
    en: 'Mother',
    th: 'แม่',
    lo: 'ແມ່',
    vi: 'Mẹ',
    zh: '母亲',
  },
  // Grandparents - Paternal
  'Nang': {
    mien: 'Nang',
    en: 'Paternal Grandfather',
    th: 'ปู่',
    lo: 'ປູ່',
    vi: 'Ông nội',
    zh: '祖父',
  },
  'Nyang': {
    mien: 'Nyang',
    en: 'Paternal Grandmother',
    th: 'ย่า',
    lo: 'ຍ່າ',
    vi: 'Bà nội',
    zh: '祖母',
  },
  // Grandparents - Maternal
  'Ndaav nyiem': {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandfather',
    th: 'ตา',
    lo: 'ຕາ',
    vi: 'Ông ngoại',
    zh: '外祖父',
  },
  'Ndaav nyiem (f)': {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandmother',
    th: 'ยาย',
    lo: 'ຍາຍ',
    vi: 'Bà ngoại',
    zh: '外祖母',
  },
  // Father's side
  'Dauv lung': {
    mien: 'Dauv lung',
    en: "Uncle (Father's side)",
    th: 'ลุง',
    lo: 'ລຸງ',
    vi: 'Bác trai nội',
    zh: '伯父',
  },
  'Dauv ntsaav': {
    mien: 'Dauv ntsaav',
    en: "Uncle (Mother's side husband)",
    th: 'น้าชาย',
    lo: 'ນ້າຊາຍ',
    vi: 'Cậu ngoại',
    zh: '舅舅',
  },
  'Dauv mbing': {
    mien: 'Dauv mbing',
    en: "Aunt (Father's side)",
    th: 'ป้า',
    lo: 'ປ້າ',
    vi: 'Bác gái nội',
    zh: '姑妈',
  },
  'Dauv hlua': {
    mien: 'Dauv hlua',
    en: 'Older Brother',
    th: 'พี่ชาย',
    lo: 'ພີ່ຊາຍ',
    vi: 'Anh trai',
    zh: '哥哥',
  },
  'Mbing': {
    mien: 'Mbing',
    en: "Aunt (Father's side wife)",
    th: 'ป้า',
    lo: 'ປ້າ',
    vi: 'Thím',
    zh: '婶母',
  },
  // Mother's side
  'Nerh ntsaav': {
    mien: 'Nerh ntsaav',
    en: "Aunt (Mother's side)",
    th: 'น้าสาว',
    lo: 'ອ້າຍສາວ',
    vi: 'Dì ngoại',
    zh: '小姨',
  },
  'Nerh dauv': {
    mien: 'Nerh dauv',
    en: "Uncle (Mother's side)",
    th: 'น้าชาย',
    lo: 'ນ້າຊາຍ',
    vi: 'Cậu',
    zh: '舅舅',
  },
  'Nerh ncaav': {
    mien: 'Nerh ncaav',
    en: 'Younger Sister',
    th: 'น้องสาว',
    lo: 'ນ້ອງສາວ',
    vi: 'Em gái',
    zh: '妹妹',
  },
  // Uncle/Aunt family members
  "Uncle's Father": {
    mien: 'Dauv',
    en: "Uncle's Father",
    th: 'พ่อ',
    lo: 'ພໍ່',
    vi: 'Cha',
    zh: '父亲',
  },
  "Uncle's Mother": {
    mien: 'Nerh',
    en: "Uncle's Mother",
    th: 'แม่',
    lo: 'ແມ່',
    vi: 'Mẹ',
    zh: '母亲',
  },
  "Uncle's Paternal Grandfather": {
    mien: 'Nang',
    en: 'Paternal Grandfather',
    th: 'ปู่',
    lo: 'ປູ່',
    vi: 'Ông nội',
    zh: '祖父',
  },
  "Uncle's Paternal Grandmother": {
    mien: 'Nyang',
    en: 'Paternal Grandmother',
    th: 'ย่า',
    lo: 'ຍ່າ',
    vi: 'Bà nội',
    zh: '祖母',
  },
  "Uncle's Maternal Grandfather": {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandfather',
    th: 'ตา',
    lo: 'ຕາ',
    vi: 'Ông ngoại',
    zh: '外祖父',
  },
  "Uncle's Maternal Grandmother": {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandmother',
    th: 'ยาย',
    lo: 'ຍາຍ',
    vi: 'Bà ngoại',
    zh: '外祖母',
  },
  "Uncle's Older Brother": {
    mien: 'Dauv hlua',
    en: 'Older Brother',
    th: 'พี่ชาย',
    lo: 'ພີ່ຊາຍ',
    vi: 'Anh trai',
    zh: '哥哥',
  },
  "Uncle's Younger Sister": {
    mien: 'Nerh ncaav',
    en: 'Younger Sister',
    th: 'น้องสาว',
    lo: 'ນ້ອງສາວ',
    vi: 'Em gái',
    zh: '妹妹',
  },
  "Uncle's Paternal Uncle": {
    mien: 'Dauv lung',
    en: 'Paternal Uncle',
    th: 'ลุง',
    lo: 'ລຸງ',
    vi: 'Bác trai nội',
    zh: '伯父',
  },
  "Uncle's Maternal Aunt": {
    mien: 'Nerh ntsaav',
    en: 'Maternal Aunt',
    th: 'น้าสาว',
    lo: 'ອ້າຍສາວ',
    vi: 'Dì ngoại',
    zh: '小姨',
  },
  "Aunt's Father": {
    mien: 'Dauv',
    en: "Aunt's Father",
    th: 'พ่อ',
    lo: 'ພໍ່',
    vi: 'Cha',
    zh: '父亲',
  },
  "Aunt's Mother": {
    mien: 'Nerh',
    en: "Aunt's Mother",
    th: 'แม่',
    lo: 'ແມ່',
    vi: 'Mẹ',
    zh: '母亲',
  },
  "Aunt's Paternal Grandfather": {
    mien: 'Nang',
    en: 'Paternal Grandfather',
    th: 'ปู่',
    lo: 'ປູ່',
    vi: 'Ông nội',
    zh: '祖父',
  },
  "Aunt's Paternal Grandmother": {
    mien: 'Nyang',
    en: 'Paternal Grandmother',
    th: 'ย่า',
    lo: 'ຍ່າ',
    vi: 'Bà nội',
    zh: '祖母',
  },
  "Aunt's Maternal Grandfather": {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandfather',
    th: 'ตา',
    lo: 'ຕາ',
    vi: 'Ông ngoại',
    zh: '外祖父',
  },
  "Aunt's Maternal Grandmother": {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandmother',
    th: 'ยาย',
    lo: 'ຍາຍ',
    vi: 'Bà ngoại',
    zh: '外祖母',
  },
  "Aunt's Older Sister": {
    mien: 'Nerh hluav',
    en: 'Older Sister',
    th: 'พี่สาว',
    lo: 'ພີ່ສາວ',
    vi: 'Chị gái',
    zh: '姐姐',
  },
  "Aunt's Younger Brother": {
    mien: 'Dauv ncaav',
    en: 'Younger Brother',
    th: 'น้องชาย',
    lo: 'ນ້ອງຊາຍ',
    vi: 'Em trai',
    zh: '弟弟',
  },
  "Aunt's Maternal Uncle": {
    mien: 'Nerh dauv',
    en: 'Maternal Uncle',
    th: 'น้าชาย',
    lo: 'ນ້າຊາຍ',
    vi: 'Cậu',
    zh: '舅舅',
  },
  // Paternal Grandfather/Grandmother (labels)
  'Paternal Grandfather': {
    mien: 'Nang',
    en: 'Paternal Grandfather',
    th: 'ปู่',
    lo: 'ປູ່',
    vi: 'Ông nội',
    zh: '祖父',
  },
  'Paternal Grandmother': {
    mien: 'Nyang',
    en: 'Paternal Grandmother',
    th: 'ย่า',
    lo: 'ຍ່າ',
    vi: 'Bà nội',
    zh: '祖母',
  },
  'Maternal Grandfather': {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandfather',
    th: 'ตา',
    lo: 'ຕາ',
    vi: 'Ông ngoại',
    zh: '外祖父',
  },
  'Maternal Grandmother': {
    mien: 'Ndaav nyiem',
    en: 'Maternal Grandmother',
    th: 'ยาย',
    lo: 'ຍາຍ',
    vi: 'Bà ngoại',
    zh: '外祖母',
  },
};

/**
 * Get the kinship term in the specified language.
 * Falls back to Mien, then to the original term if not found.
 */
export function getTranslatedTerm(kinshipTerm, language) {
  if (!kinshipTerm) return '';
  if (language === 'mien') return kinshipTerm; // Mien is the default

  const entry = TRANSLATIONS[kinshipTerm];
  if (entry && entry[language]) {
    return entry[language];
  }

  // Fallback to English if the language isn't found
  if (entry && entry.en) {
    return entry.en;
  }

  // Final fallback: return the original Mien term
  return kinshipTerm;
}

/**
 * Get all available translations for a kinship term.
 * Returns an array of { code, label, term, flag } for all languages.
 */
export function getAllTranslations(kinshipTerm) {
  if (!kinshipTerm) return [];

  const entry = TRANSLATIONS[kinshipTerm];
  if (!entry) return [];

  return SUPPORTED_LANGUAGES.map(lang => ({
    code: lang.code,
    label: lang.label,
    flag: lang.flag,
    term: entry[lang.code] || kinshipTerm,
  }));
}